import CriticalityService from "../../Services/CriticalityService";

export const GETCRITICALITYCOUNT = "GETCRITICALITYCOUNT";
export const GETCRITICALITYCOUNTFAILED = "GETCRITICALITYCOUNTFAILED";
export const SET_CRITICALITY_TYPE = "SET_CRITICALITY_TYPE";

export const setCriticalityType = (type) => ({
  type: SET_CRITICALITY_TYPE,
  payload: type,
});

export const getCriticalityCount = () => async (dispatch) => {
  try {
    const loggedUserJson = localStorage.getItem("login_result");
    const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

    let payload = {
      user_account_Id: loggedUser.user.account_Id,
    };

    const response = await CriticalityService.CriticalityCount(payload);

    dispatch({
      type: GETCRITICALITYCOUNT,
      payload: response?.data,
    });
  } catch (error) {
    dispatch({ type: GETCRITICALITYCOUNTFAILED });
  }
};
